import { createContext, useContext, useMemo, useState } from 'react'

const SharingContext = createContext<{ dirty?: boolean; setDirty?: (d) => void } | undefined>(undefined)

export function SharingProvider(props) {
  const [dirty, setDirty] = useState<boolean | string>(false)
  const value = useMemo(
    () => ({
      dirty,
      setDirty
    }),
    [dirty, setDirty]
  )

  return <SharingContext.Provider value={value} {...props} />
}

export function useSharingContext() {
  const context = useContext(SharingContext)
  if (!context) {
    throw new Error('useSharingContext must be used within a SharingProvider')
  }

  return context
}
